// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-3oa","importantInfo":"styles_importantInfo__2ju6Q"};